import styled from 'styled-components';

const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin: 2.4rem 0;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export { Pagination, Container };
